import { Grid, TextField } from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import { useCallCenter } from "../../../../context/CallCenterContext";

export default function FormDiagnostico() {
    const { formDiagnostico, handleChangeFormDiagnosticoText, handleChangeFormDiagnosticoUDec } = useCallCenter();

    const {
        txtCCSintomas,
        txtCCDiagnostico,
        txtCCTratamiento,
        txtCCPeso,
        txtCCAltura,
        txtCCAlergias,
        txtCCComentarios,
    } = formDiagnostico;

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} className="center">
                <span className="rob-con normal size-15 color-3">
                    (Los datos de esta sección se guardarán automáticamente al finalizar la consulta).
                </span>
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCPeso"
                    label={txtCCPeso.label}
                    value={txtCCPeso.value}
                    onChange={handleChangeFormDiagnosticoUDec}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCAltura"
                    label={txtCCAltura.label}
                    value={txtCCAltura.value}
                    onChange={handleChangeFormDiagnosticoUDec}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCAlergias"
                    label={txtCCAlergias.label}
                    value={txtCCAlergias.value}
                    onChange={handleChangeFormDiagnosticoText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    multiline
                />
            </Grid>
            <Grid item sm={6} xs={12}>
                <TextField
                    name="txtCCSintomas"
                    label={txtCCSintomas.label}
                    value={txtCCSintomas.value}
                    onChange={handleChangeFormDiagnosticoText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    multiline
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="txtCCDiagnostico"
                    label={txtCCDiagnostico.label}
                    value={txtCCDiagnostico.value}
                    onChange={handleChangeFormDiagnosticoText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    multiline
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="txtCCTratamiento"
                    label={txtCCTratamiento.label}
                    value={txtCCTratamiento.value}
                    onChange={handleChangeFormDiagnosticoText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    multiline
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="txtCCComentarios"
                    label={txtCCComentarios.label}
                    value={txtCCComentarios.value}
                    onChange={handleChangeFormDiagnosticoText}
                    variant={inputVariant}
                    color={inputColor}
                    fullWidth
                    multiline
                />
            </Grid>
        </Grid>
    );
}
